// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__2ZhZ0","col":"CardReaderDesc_col__12fgA","label":"CardReaderDesc_label__1i80R"};